<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import auth from '../services/auth';

const router = useRouter();
const userInfo = ref({
  username: '',
  email: '',
  name: '',
});
const showDropdown = ref(false);

onMounted(async () => {
  try {
    const user = await auth.getCurrentUser();
    userInfo.value = user;
  } catch (error) {
    console.error('Failed to get user info:', error);
    // 取得失敗時はログイン画面に遷移
    router.push('/login');
  }
});

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const handleLogout = () => {
  auth.signOut();
  router.push('/login');
};
</script>

<template>
  <nav class="navbar bg-body-tertiary bg-dark border-bottom border-bottom-dark p-0" data-bs-theme="dark">
    <a class="navbar-brand" href="#">
      <button class="navbar-toggler" id="btnLeftCanvas" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasLeft" aria-controls="offcanvasLeft">
        <span class="navbar-toggler-icon"></span>
      </button>
      Drone Mapping <i class="bi bi-geo-alt-fill"></i>
    </a>
    <div class="user-menu me-3">
      <button class="user-menu-button" @click="toggleDropdown" @blur="showDropdown = false">
        <i class="bi bi-person-circle"></i>
      </button>
      <div v-if="showDropdown" class="dropdown-menu-custom">
        <div class="user-info">
          <div class="user-name">{{ userInfo.name || userInfo.username }}</div>
          <div class="user-email">{{ userInfo.email }}</div>
        </div>
        <hr class="dropdown-divider">
        <button class="dropdown-item" @mousedown="handleLogout">
          <i class="bi bi-box-arrow-right me-2"></i>
          ログアウト
        </button>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.user-menu {
  position: relative;
}

.user-menu-button {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
}

.user-menu-button:hover {
  color: #ccc;
}

.dropdown-menu-custom {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  min-width: 250px;
  z-index: 1000;
  margin-top: 0.5rem;
}

.user-info {
  padding: 0.75rem 1rem;
  color: #212529;
}

.user-name {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.25rem;
}

.user-email {
  font-size: 0.875rem;
  color: #6c757d;
}

.dropdown-divider {
  margin: 0;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: left;
  background-color: transparent;
  border: 0;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-item i {
  width: 1.25rem;
}
</style>
